import { ImageDisplayStyle } from '../types/model/common';
import { SectionConfigOnView } from '../types/onView/common';

export type SectionEstimateConfig = {
  enabled: boolean;
  displayStyle: ImageDisplayStyle;
};

export function readSectionEstimateConfigFromOnView(
  config: SectionConfigOnView
): SectionEstimateConfig {
  return {
    enabled: config.enabled,
    displayStyle: config.displayStyle._id,
  };
}
